import { memo } from "react";
import * as Styled from "./style";
import { Product } from "~/components/blocks/product";
import { DetailHeader } from "~/components/blocks/product/detail/header";
import { useDetailProduct } from "~/components/blocks/product/hooks/use-detail-product";
import { useDetailProductViewItem } from "~/components/blocks/product/hooks/use-detail-product-view-item";
import { DetailProductSkeleton } from "~/components/stores/detail-product/skeleton";
import { isLoadingAPIVar, productDetailVar } from "~/components/stores/detail-product/store";
import { useIsomorphicEffect } from "~/hooks/use-isomorphic-effect";
import { isBot } from "~/util/is-bot";

/** 作品の詳細情報を表示するコンポーネント */
export const DetailProductStore = memo(() => {
  const { isVideoLoading, videoData } = useDetailProduct();
  const isomorphicEffect = useIsomorphicEffect();

  isomorphicEffect(() => {
    isLoadingAPIVar(isVideoLoading || !videoData);
    productDetailVar(videoData);
  }, [isVideoLoading, videoData]);

  useDetailProductViewItem({ isVideoLoading, videoData: videoData?.video });

  const element = (
    <Styled.DivMaxWidth role="presentation">
      <DetailHeader videoData={videoData} />
      <Product videoData={videoData} />
    </Styled.DivMaxWidth>
  );

  if (videoData && isBot()) return element;
  if (isVideoLoading || !videoData) return <DetailProductSkeleton />;

  return element;
});

DetailProductStore.displayName = "DetailProductStore";
